import { Banknote, Landmark, Mountain, Receipt, Scale, type LucideIcon } from 'lucide-react';

export interface SolutionSummary {
  slug: string;
  name: string;
  shortDescription: string;
  icon: LucideIcon;
  href: string;
}

/**
 * Master list of Justisio industry solutions. Consumed by the `/solusi` index
 * page and the navbar dropdown so the two never drift out of sync.
 */
export const SOLUTIONS: readonly SolutionSummary[] = [
  {
    slug: 'pertambangan-energi-sda',
    name: 'Pertambangan, Energi & SDA',
    shortDescription:
      'Tinjauan lebih cepat, kepatuhan yang lebih kuat untuk tim hukum sektor tambang dan energi.',
    icon: Mountain,
    href: '/solusi/pertambangan-energi-sda',
  },
  {
    slug: 'fintech-multifinance',
    name: 'Fintech & Multifinance',
    shortDescription:
      'Akselerasi pencairan dana tanpa kompromi pada kepatuhan untuk fintech dan multifinance.',
    icon: Banknote,
    href: '/solusi/fintech-multifinance',
  },
  {
    slug: 'perbankan',
    name: 'Perbankan',
    shortDescription:
      'Validasi lebih cepat, risiko terkendali, kepatuhan tanpa kompromi untuk tim hukum perbankan.',
    icon: Landmark,
    href: '/solusi/perbankan',
  },
  {
    slug: 'perpajakan-bea-cukai',
    name: 'Perpajakan & Bea Cukai',
    shortDescription:
      'Tinjauan lebih cepat, kepatuhan yang lebih kuat untuk konsultan pajak, divisi Tax & Customs, dan firma hukum.',
    icon: Receipt,
    href: '/solusi/perpajakan-bea-cukai',
  },
  {
    slug: 'litigasi',
    name: 'Litigasi',
    shortDescription:
      'Strategi lebih tajam, pembuktian lebih kuat untuk firma hukum litigasi dan tim dispute resolution korporasi.',
    icon: Scale,
    href: '/solusi/litigasi',
  },
] as const;
